import { render, staticRenderFns } from "./select-files-step.vue?vue&type=template&id=351c0852"
import script from "./select-files-step.vue?vue&type=script&lang=ts"
export * from "./select-files-step.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports